import { createMuiTheme } from '@material-ui/core/styles';


export default function StoreTheme(theme, brandColor)
{
    return createMuiTheme({
        ...theme,
        ColorC1: brandColor,
        ColorC2: theme.ColorBlue,
        overrides: {
            MuiListItem: {
                root: {
                    "&$selected": {
                        backgroundColor: theme.ColorBlue,
                        color: "white",
                    },
                    "&:hover": {
                        color: theme.ColorBlue,
                    }, 
                },
            },
            MuiListItemIcon: {
                root: {
                    color: "inherit"
                }
            },
            MuiButton: {
                root: {
                    borderRadius: 0,
                    textTransform: "none",
                    textDecoration: "none",
                    textAlign: "center",
                  }
            }
        }
    });
}